/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  ProductsCategory.tsx
*
* Project Title :  Checkout
*
* Description	: Purchase Software page
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H175591
*
* @Date		    : Oct 1, 2019
*
* @Version      : Version 1.0
*
******************************************************************************/
import React from 'react';
import { Grid, Select } from '@scuf/common';
import { SelectComponentProps } from '../../../../types/index';
import { SelectCategoryValue } from '..';

interface ProductCategoryPropsI {
    selectOptions: SelectComponentProps<SelectCategoryValue>[],
    selectedCategoryId: string,
    setSelectedCategory: Function,
}

function ProductsCategory(props: ProductCategoryPropsI | any) {
    return (
            <Grid.Row>
                <Grid.Column>
                    <Select
                        placeholder="View All Products"
                        defaultValue={props.selectedCategoryId}
                        indicator="required"
                        options={props.selectOptions.categoryList}
                        onChange={props.setSelectedCategory}
                        className="productCategorySearch"
                    />
                </Grid.Column>
            </Grid.Row>
    );
}

export default ProductsCategory;